import React from 'react';
import jwtDecode from 'jwt-decode';
import { capitalize } from 'lodash';
import {
  Button,
} from 'reactstrap';
import appSyncClient from '../../../appsync/client';
import addSocialProvider from '../../../appsync/mutations/AddSocialProvider';
import SITE_PATHS from '../../../config/sitePaths';
import { getHashValue, getQueryParameter } from '../../../utils/urlHelpers';
import Loader from '../../Loader';
import { postSocialData } from '../../../services/scoringService';
import { findByConnectionName } from '../../../containers/SocialProvidersList/providersConfig';
import { getScoringRequest } from '../../../services/loanRetrievalService';
import Text from '../../Text';

import './style.scss';

function parseProvider(providerField) {
  return providerField.split('|').shift();
}

function sendSocialDataToWarehouse(
  clientId,
  requestId,
  providerName,
  idToken,
) {
  const providerConfig = findByConnectionName(providerName);
  return postSocialData({
    idToken,
    clientId,
    miningId: requestId,
    type: capitalize(providerConfig.providerName),
  });
}

function saveProviderConnection(requestId, providerName, decoded) {
  const { name, email, picture } = decoded;
  return appSyncClient.mutate({
    mutation: addSocialProvider(requestId, providerName, name, email, picture),
  });
}

class SocialProviderCallback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scoringRequest: null,
      error: false,
    };
  }

  componentDidMount() {
    this.processCallback();
  }

  handleOnClick() {
    if (this.state.scoringRequest) {
      this.goToSocialConnectors();
    } else {
      this.process();
    }
  }

  goToSocialConnectors() {
    this.props.resumeWizard(
      SITE_PATHS.SOCIAL_CONNECTORS,
      this.props.history,
      {
        scoringRequest: this.state.scoringRequest,
      },
    );
  }

  processCallback() {
    const clientId = getQueryParameter('clientId');
    const requestId = getQueryParameter('requestId');

    getScoringRequest(clientId, requestId)
      .then((scoringRequest) => {
        if (scoringRequest.errorMessage) throw scoringRequest.errorMessage;
        this.setState({ scoringRequest });
        const { hash } = this.props.location;
        const idToken = getHashValue(hash, 'id_token');

        if (!idToken) {
          const error = getHashValue(hash, 'error');
          const errorDescription = getHashValue(hash, 'error_description');
          console.error('No token provided.', error, errorDescription); // eslint-disable-line no-console
          this.setState({ error: true });
          return;
        }

        const decoded = jwtDecode(idToken);
        const providerName = parseProvider(decoded.sub);

        const promises = [
          sendSocialDataToWarehouse(clientId, requestId, providerName, idToken),
          saveProviderConnection(requestId, providerName, decoded),
        ];
        return Promise.all(promises); // eslint-disable-line consistent-return
      }).then(() => this.goToSocialConnectors())
      .catch((error) => {
        console.error(error); // eslint-disable-line no-console
        this.setState({ error: true });
      });
  }

  renderError() {
    return (
      <div className="error-container">
        <div className="error-message">
          <Text value="Unable to connect social account. Please try again later." />
        </div>
        <Button
          color="success"
          onClick={() => this.handleOnClick()}
        >
          { this.state.scoringRequest
            ? <Text value="Go Back" />
            : <Text value="Retry" /> }
        </Button>
      </div>
    );
  }

  render() {
    if (this.state.error) {
      return this.renderError();
    }
    return (
      <Loader />
    );
  }
}

export default SocialProviderCallback;
